export const changeElementWidth = payload => {
  return {
    type: 'CHANGE_WIDTH',
    payload: payload,
  };
};
